import script from "./StudentFormEvaluation.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentFormEvaluation.vue?vue&type=script&setup=true&lang=js"

import "./StudentFormEvaluation.vue?vue&type=style&index=0&id=5cd3b2b1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd3b2b1"]])

export default __exports__